import React, { useState } from "react";
import cn from "classnames";
import styles from "./Workouts.module.sass";
import ScrollParallax from "../../../components/ScrollParallax";
import Icon from "../../../components/Icon";

// Indicateurs de suivi des élèves
const faqItems = [
  {
    id: 1,
    title: "Taux d'assiduité",
    content: "Suivez en temps réel la présence de vos élèves avec des statistiques détaillées par apprenant, formation et période. Identifiez rapidement les absences répétées.",
    details: [
      "Présence par élève et formation",
      "Évolution mensuelle de l'assiduité",
      "Alertes automatiques d'absence",
      "Comparaison inter-promotions"
    ]
  },
  {
    id: 2,
    title: "Taux de rupture",
    content: "Anticipez et réduisez les abandons grâce à un suivi précis des élèves à risque. Données essentielles pour vos rapports Qualiopi et financeurs.",
    details: [
      "Identification des élèves à risque",
      "Historique des ruptures par motif", 
      "Statistiques par formation",
      "Rapports conformes Qualiopi"
    ]
  },
  {
    id: 3,
    title: "Taux de satisfaction",
    content: "Mesurez la satisfaction de vos apprenants avec des enquêtes automatisées et des tableaux de bord dédiés. Améliorez continuellement vos formations.",
    details: [
      "Enquêtes de satisfaction automatiques",
      "Commentaires et suggestions",
      "Évolution dans le temps"
    ]
  },
  {
    id: 4,
    title: "Rapports Qualiopi",
    content: "Générez automatiquement tous les rapports nécessaires pour vos audits Qualiopi. Données certifiées et conformes aux exigences réglementaires.",
    details: [
      "Rapports d'assiduité certifiés",
      "Suivi des objectifs pédagogiques",
      "Évaluations de satisfaction",
      "Preuves de conformité"
    ]
  },
];

const SolutionEmargement = () => {
  const [activeItem, setActiveItem] = useState(null);

  const toggleItem = (id) => {
    setActiveItem(activeItem === id ? null : id);
  };

  return (
    <div className={styles.section}>
      <div className={cn("container", styles.container)}>
        <div className={styles.content}>
          {/* Côté gauche - Texte et FAQ */}
          <div className={styles.leftContent}>
            <h2 className={cn("h2", styles.title)}>
              Indicateurs de suivi des élèves
            </h2>
            <div className={styles.info}>
              Pilotez votre centre avec un suivi complet de vos apprenants. Taux d'assiduité, de rupture et de satisfaction : toutes les données essentielles pour vos audits Qualiopi.
            </div>
            
            <div className={styles.faqList}>
              {faqItems.map((item) => (
                <ScrollParallax key={item.id} className={styles.faqItem}>
                  <div
                    className={cn(styles.faqHead, { [styles.active]: activeItem === item.id })}
                    onClick={() => toggleItem(item.id)}
                  >
                    <div className={styles.faqTitle}>
                      <span className={styles.questionNumber}>
                        {item.id.toString().padStart(2, '0')}.
                      </span>
                      {item.title}
                    </div>
                    <div className={styles.faqArrow}>
                      <Icon name="arrow-bottom" size="10" />
                    </div>
                  </div>
                  <div className={cn(styles.faqBody, { [styles.visible]: activeItem === item.id })}>
                    <div className={styles.faqContent}>
                      <p>{item.content}</p>
                      {item.details && (
                        <ul className={styles.detailsList}>
                          {item.details.map((detail, index) => (
                            <li key={index} className={styles.detailItem}>
                              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className={styles.checkIcon}>
                                <path d="M13.5 4.5L6 12L2.5 8.5" stroke="#39CD54" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                              </svg>
                              {detail}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                </ScrollParallax>
              ))}
            </div>
          </div>

          {/* Côté droit - Galerie d'images */}
          <div className={styles.rightContent}>
            <div className={styles.gallery}>
              {/* Image principale au centre */}
              <div className={styles.mainImage}>
                <div className={styles.imageBackground}>
                  <ScrollParallax animateIn="fadeInUp" offset={200}>
                    <img
                      src="/images/content/emargement-illustration.svg"
                      alt="Interface principale d'émargement"
                      className={styles.centralImage}
                    />
                  </ScrollParallax>
                </div>
              </div>
              
              <ScrollParallax 
                className={styles.floatingElement} 
                animateIn="fadeInRight" 
                offset={400}
                style={{
                  position: 'absolute',
                  top: '15%',
                  right: '2%',
                  zIndex: 3
                }}
              >
                <img
                  src="/images/content/emargement-code.svg"
                  alt="Émargement par code"
                  className={styles.floatingMedium}
                />
              </ScrollParallax>
              
              <ScrollParallax 
                className={styles.floatingElement} 
                animateIn="fadeInUp" 
                offset={500}
                style={{
                  position: 'absolute',
                  bottom: '-15%',
                  left: '8%',
                  zIndex: 4
                }}
              >
                <img
                  src="/images/content/emargement-qr.svg"
                  alt="Émargement direct"
                  className={styles.floatingLarge}
                />
              </ScrollParallax>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SolutionEmargement;
